import React from "react";
import { motion as m } from "framer-motion";

/**
 * Soft upward reveal used across the site.
 * direction: "up" | "down" | "left" | "right" | "none"
 */
const offsets = {
  up: { y: 28, x: 0 },
  down: { y: -28, x: 0 },
  left: { y: 0, x: 36 },
  right: { y: 0, x: -36 },
  none: { y: 0, x: 0 },
};

const Reveal = ({
  children,
  delay = 0,
  duration = 0.7,
  direction = "up",
  once = true,
  amount = 0.3,
  className = "",
  as = "div",
}) => {
  const Comp = m[as] || m.div;
  const offset = offsets[direction] || offsets.up;

  return (
    <Comp
      className={className}
      initial={{ opacity: 0, ...offset }}
      whileInView={{ opacity: 1, y: 0, x: 0 }}
      viewport={{ once, amount }}
      transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </Comp>
  );
};

export default Reveal;
